export default function CategoryShimmer() {
  return (
    <div className="agentinfobox-container">
      <div className="category-heading">
        <p className="category-title">Projects</p>
      </div>

      <div className="grid">
        {Array.from({ length: 10 }).map((_, i) => (
          <div key={i} className="linkClass">
            <div className="grid-item-shimmer"></div>
          </div>
        ))}
      </div>
    </div>
  );
}